import TableColumn from '@models/table-column';

export const COLUMN_TABLE_REPARTITION_TOP_UPS: TableColumn[] = [
  {
    name: 'ESTABLISHMENT',
    orderable: true,
    sortingField: '',
  },
  {
    name: 'THRESHOLD',
    orderable: false,
    sortingField: '',
  },
  {
    name: 'CREDIT',
    orderable: false,
    sortingField: '',
  },
];
